import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Breakpoint } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { forwardRef, useState } from 'react';
import { Container } from '../../../../components/SearchForm/components/AirportsWidget/components/Container.js';
import { Content } from '../../../../components/SearchForm/components/AirportsWidget/components/Content.js';
import { CountryList } from '../../../../components/SearchForm/components/AirportsWidget/components/CountryList/index.js';
import { RegionList } from '../../../../components/SearchForm/components/AirportsWidget/components/RegionList.js';
import { Suggestions } from '../../../../components/SearchForm/components/AirportsWidget/components/Suggestions/index.js';
import { Headline } from '../../../../components/SearchForm/components/TravellersWidget/components/Headline.js';
import { WidgetOverlay } from '../../../../components/SearchForm/components/WidgetOverlay/index.js';
import { Button, Checkbox, LabelMediumBold, LabelXSmall, Stack } from '../../../../primitives/index.js';
import { qaId } from '../../../../utils/index.js';
import { SEARCH_FORM_QA_ID } from '../../../../utils/qaId.js';
import { SPACING_MEDIUM, SPACING_NONE, SPACING_SMALL } from '../../../../utils/spacingLegacy.js';
export const AirportsWidget = forwardRef(function AirportsWidgetNew({
  type,
  open,
  data,
  dimming,
  handlers,
  config,
  layout,
  widgetHead,
  ...restProps
}, ref) {
  const {
    t
  } = useTranslation();
  const {
    countryList,
    nearbyAirports
  } = data;
  const {
    countryCode,
    enableSelectAll,
    showSuggestions
  } = config;
  const {
    onCheck,
    isChecked,
    onReset,
    onClose,
    onApply,
    onInputChange
  } = handlers;
  const [showRegionList, setShowRegionList] = useState(true);
  return _jsx(WidgetOverlay, {
    type: type,
    open: open,
    dim: dimming || layout === 'compact' || layout === 'sidebar',
    children: _jsx(Container, {
      removePadding: true,
      ...restProps,
      ref: ref,
      type: type,
      head: widgetHead,
      title: t('airportsWidget:title.dialog'),
      onClose: onClose,
      controls: [_jsx(Button, {
        onClick: onReset,
        "data-testid": qaId(SEARCH_FORM_QA_ID, 'airports-reset-button'),
        category: "secondary",
        children: t('airportsWidget:button.reset')
      }, "reset-button"), _jsx(Button, {
        onClick: onApply,
        "data-testid": qaId(SEARCH_FORM_QA_ID, 'airports-apply-button'),
        children: t('airportsWidget:button.apply')
      }, "apply-button")],
      "data-testid": "airports-widget",
      children: _jsxs(Content, {
        spacing: SPACING_SMALL,
        "data-testid": qaId(SEARCH_FORM_QA_ID, 'airportLayer'),
        children: [_jsx(Breakpoint, {
          matches: ['xs', 'sm', 'md'],
          children: _jsx(Headline, {
            children: t('airportsWidget:title.content')
          })
        }), showSuggestions && _jsx(Suggestions, {
          nearbyAirports: nearbyAirports,
          isChecked: isChecked,
          onCheck: onCheck,
          onToggle: setShowRegionList,
          onInputChange: onInputChange
        }), showRegionList && _jsx(RegionList, {
          spacing: SPACING_MEDIUM,
          justifyContent: "space-between",
          divider: true,
          children: _jsxs(Stack, {
            spacing: SPACING_NONE,
            children: [enableSelectAll && countryCode === 'de' && _jsx(Checkbox, {
              checked: isChecked(countryCode),
              value: countryCode,
              label: _jsxs(Stack, {
                direction: "row",
                alignItems: "center",
                "data-testid": qaId(SEARCH_FORM_QA_ID, 'airport-first-country'),
                children: [_jsx(LabelMediumBold, {
                  children: t(`airportsWidget:label.${countryCode}`)
                }), _jsx(LabelXSmall, {
                  truncate: true,
                  color: "contentTertiary",
                  children: t(`airportsWidget:label.allAirports`)
                })]
              }),
              onChange: onCheck
            }), _jsx(CountryList, {
              data: countryList,
              isChecked: isChecked,
              onCheck: onCheck
            })]
          })
        })]
      })
    })
  });
});